import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDetailLayoutComponent } from './product-detail-layout.component';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { TranslateModule } from '@shared/translate/translate.module';
import {
  BreadcrumbsModule,
  FlexboxModule,
  GridModule,
  PanelModule,
  ProximalModule,
  SectionHeaderModule,
  SpacingModule,
  PaddingModule,
  TabsModule,
  TabsStickyModule,
  TitleModule,
  ProgressBarModule,
} from '@frk/eds-components';
import { BrSdkModule } from '@bloomreach/ng-sdk';

@NgModule({
  declarations: [ProductDetailLayoutComponent],
  imports: [
    CommonModule,
    TranslateModule,
    PanelModule,
    TitleModule,
    TabsModule,
    SpacingModule,
    GridModule,
    BreadcrumbsModule,
    SectionHeaderModule,
    TabsStickyModule,
    ProximalModule,
    BrSdkModule,
    FlexboxModule,
    PaddingModule,
    ProgressBarModule,
  ],
})
export class ProductDetailLayoutModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      productDetailLayout: ProductDetailLayoutComponent,
    };
  }
}
